<template>
  <div class="form" style="height: 480px; overflow-x:auto">
    <el-row style=" margin-top: 20px;">
      <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="7" style="text-align: right;margin-right: 2%">阿里云短信：</el-col>
      <el-col :xl="18" :lg="18" :md="18" :sm="18" :xs="16">
        <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23">
          <el-switch
            style="display: block;"
            v-model="shortMessageNoticeData.alibabaCloudSMSVal"
            active-color="#13ce66"
            inactive-color="#ff4949"
            inactive-text="禁用"
            active-text="启用">
          </el-switch>
        </el-col>
        <el-form v-if="shortMessageNoticeData.alibabaCloudSMSVal" label-width="80px">
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" style="margin-top: 20px;">
            <el-form-item label="ID:">
              <el-input placeholder="请输入阿里云短信ID" size="mini" v-model="alibabaCloudSMSIDData.val1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
            <el-form-item label="密钥:">
              <el-input placeholder="请输入阿里云短信密钥" size="mini" v-model="alibabaCloudSMSKeyData.val1"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
    </el-row>

    <el-row style="margin-top: 30px;">
      <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="7" style="text-align: right;margin-right: 2%">串口短信：</el-col>
      <el-col :xl="18" :lg="18" :md="18" :sm="18" :xs="16">
        <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23">
          <el-switch
            style="display: block;"
            v-model="shortMessageNoticeData.serialSMSVal"
            active-color="#13ce66"
            inactive-color="#ff4949"
            inactive-text="禁用"
            active-text="启用">
          </el-switch>
        </el-col>
        <el-form  v-if="shortMessageNoticeData.serialSMSVal" label-width="80px">
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" style="margin-top: 20px;">
            <el-form-item label="COM口:">
              <el-input placeholder="请输入串口COM口" size="mini" v-model="serialSMSCOMData.val1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
            <el-form-item label="中心号码:">
              <el-input placeholder="请输入串口中心号码" size="mini" v-model="centerNumberData.val1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
            <el-form-item label="发送号码:">
              <el-input placeholder="请输入串口发送号码" size="mini" v-model="sendingNumberData.val1"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
    </el-row>

    <el-row style="margin-top: 30px;">
      <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="7" style="text-align: right;margin-right: 2%">主机短信：</el-col>
      <el-col :xl="18" :lg="18" :md="18" :sm="18" :xs="16">
        <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23">
          <el-switch
            style="display: block;"
            v-model="shortMessageNoticeData.hostSMSVal"
            active-color="#13ce66"
            inactive-color="#ff4949"
            inactive-text="禁用"
            active-text="启用">
          </el-switch>
        </el-col>

        <space-host v-if="shortMessageNoticeData.hostSMSVal"
                    :gatewayList="gatewayList"
                    :gatewaySn="gatewaySn"
                    :spaceHostList="spaceHostList"
                    :spaceList="spaceList"
                    :type="type"
                    :wholeSpace="this.wholeSpace"
                    @setGatewaySn="setNotificationConfigurationGatewaySn"
                    @setWholeSpace="setNotificationConfigurationWholeSpace"></space-host>
      </el-col>
    </el-row>

    <el-row style=" margin-top: 30px;">
      <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="7" style="text-align: right;margin-right: 2%">自定义通道：</el-col>
      <el-col :xl="18" :lg="18" :md="18" :sm="18" :xs="16">
        <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23">
          <el-switch
            style="display: block;"
            v-model="shortMessageNoticeData.customVal"
            active-color="#13ce66"
            inactive-color="#ff4949"
            inactive-text="禁用"
            active-text="启用">
          </el-switch>
        </el-col>
        <el-form v-if="shortMessageNoticeData.customVal" label-width="80px">
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" style="margin-top: 20px;">
            <el-form-item label="通道地址:">
              <el-input placeholder="请输入通道地址" size="mini" v-model="customUrl.val1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23">
            <el-form-item label="请求方式:">
              <!--              <el-input placeholder="请输入请求方式" size="mini" v-model="customMethod.val1"></el-input>-->
              <el-radio-group v-model="customMethod.val1">
                <el-radio label="POST">POST</el-radio>
                <el-radio label="GET">GET</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-radio-group v-if="customMethod.val1 == 'POST'" v-model="customPostRequestWay.val1">
                <el-radio label="application/x-www-form-urlencoded">application/x-www-form-urlencoded</el-radio>
                <el-radio label="application/json">application/json</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
            <el-form-item label="编码格式:">
              <el-input placeholder="请输入编码格式" size="mini" v-model="customParameterFormat.val1"></el-input>
              <div style="color: red">例如:UTF-8,GBK等</div>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
            <el-form-item label="固定参数:">
              <el-input placeholder="请输入固定参数" size="mini" v-model="customParameter.val1"></el-input>
              <div style="color: red">注意：输入名称和值，多个使用&连接，例如：a=1&b=2</div>
            </el-form-item>
<!--            <el-form-item>注意：输入名称和值，多个使用&连接，例如：a=1&b=2</el-form-item>-->
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
            <el-form-item label="结果key:">
              <el-input placeholder="请输入结果key" size="mini" v-model="customResultKey.val1"></el-input>
              <div style="color: red">注意：结果key为对象的完整属性</div>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SpaceHost from "@/views/basic_operations/sys_setting/notification_configuration/public_configuration/SpaceHost";

export default {
  name: "ShortMessageNotice",
  props:["alibabaCloudSMSIDData","alibabaCloudSMSKeyData","serialSMSCOMData","centerNumberData","sendingNumberData","shortMessageNoticeData",
    "type","spaceHostList","wholeSpace","gatewaySn","spaceList","gatewayList","customUrl","customMethod","customParameter","customResultKey","customPostRequestWay","customParameterFormat"],
  components:{SpaceHost},
  // watch:{
  //   wholeSpace(newWholeSpace){
  //     this.$emit("setWholeSpace",newWholeSpace);
  //   },
  //
  //   gatewaySn(newGatewaySn){
  //     this.$emit("setGatewaySn",newGatewaySn);
  //   }
  // },
  methods:{
    setNotificationConfigurationGatewaySn(data){
      this.$emit("setGatewaySn",data);
    },
    setNotificationConfigurationWholeSpace(data){
      this.$emit("setWholeSpace",data);
    }
  }
}
</script>

<style scoped>
.form .el-form >>> .el-form-item {
  margin-bottom: 10px;
}
</style>
